'use client'

import type { Document } from '@contentful/rich-text-types'
import { ContentBlock as Block } from '@shc/ui'
import type { TypeContentBlockFields } from '@lib/generated-types/TypeContentBlock'
import { richTextRenderFactory } from '@lib/rich-text-options'
import { containerSizeMap, contentListColumnsMap, pyMap } from '@lib/token-maps'
import { usePathname } from 'next/navigation'

const ContentBlock = ({
  sectionLink,
  content,
  blockAlignment,
  textAlignment,
  width,
  listColumns,
  paddingTop,
  paddingBottom,
}: TypeContentBlockFields) => {
  const activePathname = usePathname()
  const richTextRenderChildren = richTextRenderFactory(width, !!activePathname.startsWith('/providers'))

  return (
    <Block
      as="section"
      containerAlignment={blockAlignment}
      containerSize={containerSizeMap[width]}
      contentAlignment={textAlignment}
      contentListColumns={contentListColumnsMap[listColumns]}
      id={sectionLink}
      paddingBottom={pyMap[paddingBottom]}
      paddingTop={pyMap[paddingTop]}>
      {richTextRenderChildren(content as Document)}
    </Block>
  )
}

export default ContentBlock
